import { Storage } from '@capacitor/storage'

export default {
  install: function (Vue) {
    /**
     * @typedef StoragePlugin
     */
    Vue.prototype.$storage = Storage
  }
}
